import api from "./api";
import {iniciarRequisicao, logout} from "../helpers/index.js";
import {STATUS_HTTP} from "./statusHTTP";

class FilialAPI {
  async getFiliaisGrupo(headers, params) {
    return  await api.get("/grupo/filiais", { headers, params });
  }

  async salvarGrupoFilial(headers, params) {
    const response = await api({
      method: 'post',
      url: '/filial_mapa_compra',
      headers,
      data: params
    });
    return response;
  }

  async salvarGrupoFilialSeparacao(headers, params) {
    const response = await api({
      method: 'post',
      url: '/filial_mapa_separacao',
      headers,
      data: params
    });
    return response;
  }

  async getListaMapaCompra(headers) {
    const response = await api.get("/compra_get_lista_mapa_compra", {
      headers
    });
    return response;
  }

  async getListaMapaSeparacao(headers) {
    const response = await api.get("/get_lista_mapa_separacao", {
      headers
    });
    return response;
  }

  async deletarMapaCompra(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/deletar_mapa_compra',
      headers,
      data: params
    });
    return response;
  }

  async deletarMapaSeparacao(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/deletar_mapa_separacao',
      headers,
      data: params
    });
    return response;
  }

  async setMapeamentoCategoriaDistribuicaoFilial(headers, params) {
    return await api({
      method: 'post',
      url: '/drp/filiais/mapeamento/distribuicao',
      data: params,
      headers
    })
  }

  async getListaFiliaisMapeadasPorFamilia(headers) {
    return  await api.get("/drp/filiais/mapeamento/familia", {headers});
  }

  async excluirMapeamentoFamiliaisFilial(headers, params) {
    return await api({
      method: 'delete',
      url: '/drp/filiais/mapeamento/distribuicao/exclusao',
      data: params,
      headers
    })
  }

  async deleteItensMapeamentoDistribuicao(headers, params) {
    return await api({
      method: 'delete',
      url: '/drp/filiais/mapeamento/distribuicao/exclusao/itens',
      data: params,
      headers
    })
  }

  async getCategoriasMapeadas(headers, params) {
    return await api.get("/drp/filiais/mapeamento/familia/categorias", {headers, params});
  }

  async buscarEstoquePorFilial(params) {
    const headers = iniciarRequisicao();
    const {data, status} = await api.get("/filiais/estoques", {headers, params});

    if (status !== STATUS_HTTP.OK) {
      logout();
    }

    localStorage.token = data.token;
    return data.estoques;
  }

  async buscarParametrizacaoFiliaisApiSankhya() {
    const headers = iniciarRequisicao();
    const {data, status} = await api.get("/filiais/parametrizacoes/sankhya", {headers});

    if (status !== STATUS_HTTP.OK) {
      logout();
    }

    localStorage.token = data.token;
    return data.parametrizacoes;
  }

  async salvarParametrizacaoFiliaisApiSankhya(params) {
    const headers = iniciarRequisicao();
    const {data, status} = await api.post("/filiais/parametrizacoes/sankhya", params, {headers});

    if (status !== STATUS_HTTP.OK) {
      logout();
    }

    localStorage.token = data.token;
    return true;
  }
}

export default new FilialAPI();
